<template>
    <div class="fcg-tabela-wrapper" :style="{ maxHeight: maxAltura }">
        <div v-if="semDados" class="fcg-sem-dados">Nada a exibir</div>
        <table v-else ref="tabela" class="fcg-tabela">
            <thead ref="thead">
                <!-- Linha 1: Ano -->
                <tr>
                    <th :rowspan="alturaHeader" class="col-label"
                        :style="{ position: 'sticky', top: (topOffsets[0] || 0) + 'px', zIndex: 4 }">Conta</th>
                    <th v-for="grupo in cabecalho.anos"
                        :key="'ano-' + grupo.ano"
                        :colspan="grupo.colspan"
                        :style="{ position: 'sticky', top: (topOffsets[0] || 0) + 'px', zIndex: 2 }">{{ grupo.ano }}</th>
                    <th :rowspan="alturaHeader" class="col-total-geral"
                        :style="{ position: 'sticky', top: (topOffsets[0] || 0) + 'px', zIndex: 2 }">Total<br>Geral</th>
                </tr>
                <!-- Linha 2: Mês -->
                <tr>
                    <th v-for="grupo in cabecalho.meses"
                        :key="'mes-' + grupo.id"
                        :colspan="grupo.colspan"
                        :style="{ position: 'sticky', top: (topOffsets[1] || 0) + 'px', zIndex: 2 }">{{ grupo.nome }}</th>
                </tr>
                <!-- Linha 3: Dia -->
                <tr>
                    <th v-for="dia in cabecalho.dias"
                        :key="'dia-' + dia.id"
                        :colspan="tiposPorDia(dia.dataKey).length"
                        :style="{ position: 'sticky', top: (topOffsets[2] || 0) + 'px', zIndex: 2 }">{{ dia.label }}</th>
                </tr>
                <!-- Linha 4: Tipo (só se previstoRealizado) -->
                <tr v-if="previstoRealizado" class="fcg-row-tipos">
                    <template v-for="dia in cabecalho.dias">
                        <th v-for="tipo in tiposPorDia(dia.dataKey)" :key="'tipo-' + dia.id + '-' + tipo"
                            :style="{ position: 'sticky', top: (topOffsets[3] || 0) + 'px', zIndex: 2 }">
                            {{ tipo === 'Delta' ? 'Δ' : tipo }}
                        </th>
                    </template>
                </tr>
            </thead>
            <tbody>
                <!-- ============================================================
                     SEÇÃO 1: SALDO INICIAL
                     ============================================================ -->
                <tr class="fcg-section-header" @click="toggleSecao('saldoInicial')">
                    <td :colspan="totalColunas">
                        <span class="fcg-expand-toggle">
                            {{ secoesAbertas.saldoInicial ? '▼' : '▶' }}
                        </span>
                        Saldo Inicial
                    </td>
                </tr>
                <template v-if="secoesAbertas.saldoInicial && saldoInicialData && agrupaPorTipoConta">
                    <template v-for="grupo in contasAgrupadasPorTipo(saldoInicialData)">
                        <tr class="fcg-group-header" :key="'si-gh-' + grupo.idTipoConta"
                            @click="toggleGrupo('si', grupo.idTipoConta)">
                            <td class="col-label">
                                <span class="fcg-expand-toggle">
                                    {{ grupoAberto('si', grupo.idTipoConta) ? '▼' : '▶' }}
                                </span>
                                {{ grupo.tipoConta }}
                            </td>
                            <template v-for="dia in cabecalho.dias">
                                <td v-for="tipo in tiposPorDia(dia.dataKey)"
                                    :key="'si-gh-' + grupo.idTipoConta + '-' + dia.id + '-' + tipo"
                                    :data-val="totalSaldoPorGrupoDia(saldoInicialData, grupo.contas, dia.dataKey, tipo)"
                                    :class="classeCor(totalSaldoPorGrupoDia(saldoInicialData, grupo.contas, dia.dataKey, tipo))">
                                    {{ formatBRL(totalSaldoPorGrupoDia(saldoInicialData, grupo.contas, dia.dataKey, tipo)) }}
                                </td>
                            </template>
                            <td :data-val="totalGeralPorGrupoSaldo(saldoInicialData, grupo.contas)"
                                :class="classeCor(totalGeralPorGrupoSaldo(saldoInicialData, grupo.contas))">
                                {{ formatBRL(totalGeralPorGrupoSaldo(saldoInicialData, grupo.contas)) }}
                            </td>
                        </tr>
                        <template v-if="grupoAberto('si', grupo.idTipoConta)">
                            <tr v-for="conta in grupo.contas" :key="'si-' + conta.handle">
                                <td class="col-label" :title="conta.nome">{{ conta.nome }}</td>
                                <template v-for="dia in cabecalho.dias">
                                    <td v-for="tipo in tiposPorDia(dia.dataKey)"
                                        :key="'si-c-' + conta.handle + '-' + dia.id + '-' + tipo"
                                        :data-val="getValorSaldo(saldoInicialData, conta.handle, dia.dataKey, tipo)"
                                        :class="classeCor(getValorSaldo(saldoInicialData, conta.handle, dia.dataKey, tipo))">
                                        {{ formatBRL(getValorSaldo(saldoInicialData, conta.handle, dia.dataKey, tipo)) }}
                                    </td>
                                </template>
                                <td :data-val="totalGeralPorContaSaldo(saldoInicialData, conta.handle)"
                                    :class="classeCor(totalGeralPorContaSaldo(saldoInicialData, conta.handle))">
                                    {{ formatBRL(totalGeralPorContaSaldo(saldoInicialData, conta.handle)) }}
                                </td>
                            </tr>
                        </template>
                    </template>
                </template>
                <template v-if="secoesAbertas.saldoInicial && saldoInicialData && !agrupaPorTipoConta">
                    <tr v-for="conta in contasOrdenadasFlat(saldoInicialData)" :key="'si-flat-' + conta.handle">
                        <td class="col-label" :title="conta.nome">{{ conta.nome }}</td>
                        <template v-for="dia in cabecalho.dias">
                            <td v-for="tipo in tiposPorDia(dia.dataKey)"
                                :key="'si-flat-c-' + conta.handle + '-' + dia.id + '-' + tipo"
                                :data-val="getValorSaldo(saldoInicialData, conta.handle, dia.dataKey, tipo)"
                                :class="classeCor(getValorSaldo(saldoInicialData, conta.handle, dia.dataKey, tipo))">
                                {{ formatBRL(getValorSaldo(saldoInicialData, conta.handle, dia.dataKey, tipo)) }}
                            </td>
                        </template>
                        <td :data-val="totalGeralPorContaSaldo(saldoInicialData, conta.handle)"
                            :class="classeCor(totalGeralPorContaSaldo(saldoInicialData, conta.handle))">
                            {{ formatBRL(totalGeralPorContaSaldo(saldoInicialData, conta.handle)) }}
                        </td>
                    </tr>
                </template>
                <tr class="fcg-section-total">
                    <td class="col-label">Total Saldo Inicial</td>
                    <template v-for="dia in cabecalho.dias">
                        <td v-for="tipo in tiposPorDia(dia.dataKey)"
                            :key="'si-t-' + dia.id + '-' + tipo"
                            :data-val="totalSaldoPorDia(saldoInicialData, dia.dataKey, tipo)"
                            :class="classeCor(totalSaldoPorDia(saldoInicialData, dia.dataKey, tipo))">
                            {{ formatBRL(totalSaldoPorDia(saldoInicialData, dia.dataKey, tipo)) }}
                        </td>
                    </template>
                    <td :data-val="totalGeralSecao('saldoInicial')"
                        :class="classeCor(totalGeralSecao('saldoInicial'))">
                        {{ formatBRL(totalGeralSecao('saldoInicial')) }}
                    </td>
                </tr>

                <!-- ============================================================
                     SEÇÃO 2: MOVIMENTAÇÕES (hierarquia plano gerencial 2.x)
                     ============================================================ -->
                <tr class="fcg-section-header" @click="toggleSecao('movimentacoes')">
                    <td :colspan="totalColunas">
                        <span class="fcg-expand-toggle">
                            {{ secoesAbertas.movimentacoes ? '▼' : '▶' }}
                        </span>
                        Movimentações
                    </td>
                </tr>
                <template v-if="secoesAbertas.movimentacoes">
                    <tr v-for="linha in linhasMovimentacoesVisiveis"
                        :key="'mov-' + linha.path"
                        :class="{ 'fcg-row-clickable': linha.temFilhos }"
                        @click="onLinhaClickGeral(linha)">
                        <td class="col-label"
                            :style="{ paddingLeft: (12 + linha.nivel * 12) + 'px' }"
                            :title="linha.label">
                            <span v-if="linha.temFilhos" class="fcg-expand-toggle">
                                {{ noExpandido(linha.path) ? '▼' : '▶' }}
                            </span>
                            <span v-else class="fcg-expand-spacer"></span>
                            {{ linha.label }}
                        </td>
                        <template v-for="dia in cabecalho.dias">
                            <td v-for="tipo in tiposPorDia(dia.dataKey)"
                                :key="'mov-c-' + linha.path + '-' + dia.id + '-' + tipo"
                                :data-val="getValorNo(linha, dia.dataKey, tipo)"
                                :class="classeCor(getValorNo(linha, dia.dataKey, tipo))"
                                title="Clique duas vezes na célula para visualizar o analítico"
                                @dblclick.stop="onCelulaClique(linha, dia, tipo)">
                                {{ formatBRL(getValorNo(linha, dia.dataKey, tipo)) }}
                            </td>
                        </template>
                        <td :data-val="totalGeralNo(linha)"
                            :class="classeCor(totalGeralNo(linha))">
                            {{ formatBRL(totalGeralNo(linha)) }}
                        </td>
                    </tr>
                </template>

                <!-- ============================================================
                     SEÇÃO 3: SALDO FINAL
                     ============================================================ -->
                <tr class="fcg-section-header" @click="toggleSecao('saldoFinal')">
                    <td :colspan="totalColunas">
                        <span class="fcg-expand-toggle">
                            {{ secoesAbertas.saldoFinal ? '▼' : '▶' }}
                        </span>
                        Saldo Final
                    </td>
                </tr>
                <template v-if="secoesAbertas.saldoFinal && saldoFinalData && agrupaPorTipoConta">
                    <template v-for="grupo in contasAgrupadasPorTipo(saldoFinalData)">
                        <tr class="fcg-group-header" :key="'sf-gh-' + grupo.idTipoConta"
                            @click="toggleGrupo('sf', grupo.idTipoConta)">
                            <td class="col-label">
                                <span class="fcg-expand-toggle">
                                    {{ grupoAberto('sf', grupo.idTipoConta) ? '▼' : '▶' }}
                                </span>
                                {{ grupo.tipoConta }}
                            </td>
                            <template v-for="dia in cabecalho.dias">
                                <td v-for="tipo in tiposPorDia(dia.dataKey)"
                                    :key="'sf-gh-' + grupo.idTipoConta + '-' + dia.id + '-' + tipo"
                                    :data-val="totalSaldoPorGrupoDia(saldoFinalData, grupo.contas, dia.dataKey, tipo)"
                                    :class="classeCor(totalSaldoPorGrupoDia(saldoFinalData, grupo.contas, dia.dataKey, tipo))">
                                    {{ formatBRL(totalSaldoPorGrupoDia(saldoFinalData, grupo.contas, dia.dataKey, tipo)) }}
                                </td>
                            </template>
                            <td :data-val="totalGeralPorGrupoSaldo(saldoFinalData, grupo.contas)"
                                :class="classeCor(totalGeralPorGrupoSaldo(saldoFinalData, grupo.contas))">
                                {{ formatBRL(totalGeralPorGrupoSaldo(saldoFinalData, grupo.contas)) }}
                            </td>
                        </tr>
                        <template v-if="grupoAberto('sf', grupo.idTipoConta)">
                            <tr v-for="conta in grupo.contas" :key="'sf-' + conta.handle">
                                <td class="col-label" :title="conta.nome">{{ conta.nome }}</td>
                                <template v-for="dia in cabecalho.dias">
                                    <td v-for="tipo in tiposPorDia(dia.dataKey)"
                                        :key="'sf-c-' + conta.handle + '-' + dia.id + '-' + tipo"
                                        :data-val="getValorSaldo(saldoFinalData, conta.handle, dia.dataKey, tipo)"
                                        :class="classeCor(getValorSaldo(saldoFinalData, conta.handle, dia.dataKey, tipo))">
                                        {{ formatBRL(getValorSaldo(saldoFinalData, conta.handle, dia.dataKey, tipo)) }}
                                    </td>
                                </template>
                                <td :data-val="totalGeralPorContaSaldo(saldoFinalData, conta.handle)"
                                    :class="classeCor(totalGeralPorContaSaldo(saldoFinalData, conta.handle))">
                                    {{ formatBRL(totalGeralPorContaSaldo(saldoFinalData, conta.handle)) }}
                                </td>
                            </tr>
                        </template>
                    </template>
                </template>
                <template v-if="secoesAbertas.saldoFinal && saldoFinalData && !agrupaPorTipoConta">
                    <tr v-for="conta in contasOrdenadasFlat(saldoFinalData)" :key="'sf-flat-' + conta.handle">
                        <td class="col-label" :title="conta.nome">{{ conta.nome }}</td>
                        <template v-for="dia in cabecalho.dias">
                            <td v-for="tipo in tiposPorDia(dia.dataKey)"
                                :key="'sf-flat-c-' + conta.handle + '-' + dia.id + '-' + tipo"
                                :data-val="getValorSaldo(saldoFinalData, conta.handle, dia.dataKey, tipo)"
                                :class="classeCor(getValorSaldo(saldoFinalData, conta.handle, dia.dataKey, tipo))">
                                {{ formatBRL(getValorSaldo(saldoFinalData, conta.handle, dia.dataKey, tipo)) }}
                            </td>
                        </template>
                        <td :data-val="totalGeralPorContaSaldo(saldoFinalData, conta.handle)"
                            :class="classeCor(totalGeralPorContaSaldo(saldoFinalData, conta.handle))">
                            {{ formatBRL(totalGeralPorContaSaldo(saldoFinalData, conta.handle)) }}
                        </td>
                    </tr>
                </template>
                <tr class="fcg-section-total">
                    <td class="col-label">Total Saldo Final</td>
                    <template v-for="dia in cabecalho.dias">
                        <td v-for="tipo in tiposPorDia(dia.dataKey)"
                            :key="'sf-t-' + dia.id + '-' + tipo"
                            :data-val="totalSaldoPorDia(saldoFinalData, dia.dataKey, tipo)"
                            :class="classeCor(totalSaldoPorDia(saldoFinalData, dia.dataKey, tipo))">
                            {{ formatBRL(totalSaldoPorDia(saldoFinalData, dia.dataKey, tipo)) }}
                        </td>
                    </template>
                    <td :data-val="totalGeralSecao('saldoFinal')"
                        :class="classeCor(totalGeralSecao('saldoFinal'))">
                        {{ formatBRL(totalGeralSecao('saldoFinal')) }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import FluxoCaixaExportacao from './FluxoCaixaExportacao.js';

// Normaliza qualquer representação de data para "YYYY-MM-DD" ou null se inválido.
// Aceita: ISO "YYYY-MM-DD", ISO com horário "YYYY-MM-DDT...", .NET "/Date(ms)/",
// "DD/MM/YYYY", Date nativo, objeto moment.
function normalizarParaISO(d) {
    if (!d) return null;
    if (typeof d === 'object' && typeof d.toDate === 'function') d = d.toDate();
    if (d instanceof Date) {
        if (isNaN(d.getTime())) return null;
        return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    }
    if (typeof d === 'string') {
        // ISO: "YYYY-MM-DD" ou "YYYY-MM-DDT..."
        var isoMatch = d.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (isoMatch) return isoMatch[1] + '-' + isoMatch[2] + '-' + isoMatch[3];
        // BR: "DD/MM/YYYY"
        var brMatch = d.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        if (brMatch) return brMatch[3] + '-' + brMatch[2] + '-' + brMatch[1];
        // .NET: "/Date(1234567890000)/"
        var netMatch = d.match(/\/Date\((\d+)\)\//);
        if (netMatch) {
            var nd = new Date(+netMatch[1]);
            if (!isNaN(nd.getTime()))
                return nd.getFullYear() + '-' + ('0' + (nd.getMonth() + 1)).slice(-2) + '-' + ('0' + nd.getDate()).slice(-2);
        }
    }
    if (typeof d === 'number') {
        var nd2 = new Date(d);
        if (!isNaN(nd2.getTime()))
            return nd2.getFullYear() + '-' + ('0' + (nd2.getMonth() + 1)).slice(-2) + '-' + ('0' + nd2.getDate()).slice(-2);
    }
    return null;
}

// Tabela única do Fluxo de Caixa Gerencial — substitui o dxPivotGrid + as
// TabelaSaldosBancarios separadas. Renderiza tudo em UM <table> HTML/Vue puro
// com 3 seções (Saldo Inicial / Movimentações / Saldo Final), header
// compartilhado (Ano > Mês > Dia > Tipo) e scroll horizontal único.
//
// Por que abandonamos o dxPivotGrid?
//   - Não suporta registros heterogêneos (saldos rasos vs plano profundo) sem
//     hacks DOM (rowspan, esconder TRs vazias, etc.).
//   - Quando integrado com elementos externos (TabelaSaldosBancarios), os
//     scrolls horizontais ficavam dessincronizados.
//   - Cada combinação nova de dimensões (CC, Projeto, Tipo) pode trazer caso
//     novo de visualização quebrada.
//
// Features mantidas: expand/collapse hierárquico, header hierárquico,
// cores azul/vermelho.
// Features removidas: drag de fields (cliente não usa), virtual scroll
// (renderização normal — aceita até alguns milhares de linhas tranquilo),
// fieldChooser, agregações automáticas (pré-calculamos no front).
export default {
    name: 'FluxoCaixaTabela',
    mixins: [FluxoCaixaExportacao],
    props: {
        // Movimentações 2.x do plano gerencial. Lista de Resultado do backend
        // legacy: { conta, niveisConta, centroCusto, niveisCentroCusto, projeto,
        // niveisProjeto, valor, data, tipo, empresa, filial }
        movimentacoes: { type: Array, default: function () { return []; } },
        // { contas: [{handle,nome}], datas: [Date], valores: {handle:{dataKey:{Previsto,Realizado}}} }
        saldoInicialData: { type: Object, default: function () { return null; } },
        saldoFinalData: { type: Object, default: function () { return null; } },
        previstoRealizado: { type: Boolean, default: false },
        // Configuração das dimensões hierárquicas (paridade com checkboxes "Conta 1 2 /
        // Centro de custo 1 2 / Projeto 1 2" do dxPivotGrid antigo). Cada dimensão tem:
        //   - ativo: boolean (mostra ou não a dimensão na hierarquia)
        //   - niveisVisiveis: [bool] (controla profundidade — paridade com field.visible)
        // Ordem importa: dimensões são concatenadas na hierarquia conforme essa lista.
        configDimensoes: {
            type: Object,
            default: function () {
                return {
                    conta:        { ativo: true, niveisVisiveis: [] },
                    centroCusto:  { ativo: true, niveisVisiveis: [] },
                    projeto:      { ativo: true, niveisVisiveis: [] }
                };
            }
        },
        // Altura máxima do wrapper — controla quando o scroll vertical entra.
        // Passar via prop permite que o pai ajuste conforme o layout da página.
        maxAltura: { type: String, default: '70vh' },
        agrupaPorTipoConta: { type: Boolean, default: true }
    },
    data: function () {
        return {
            // Set de paths dos nós expandidos no plano gerencial (movimentações)
            nosExpandidos: {},
            // Seções colapsáveis (Saldo Inicial, Movimentações, Saldo Final)
            secoesAbertas: {
                saldoInicial: true,
                movimentacoes: true,
                saldoFinal: true
            },
            // Grupos de tipo de conta recolhidos — chave: 'si-ID' ou 'sf-ID'
            gruposAbertos: {},
            // Offset top (px) acumulado de cada linha do thead — alimentado por
            // calcularTopOffsets() após o mount e ao alternar previstoRealizado.
            topOffsets: [0, 0, 0, 0],
            // Data de hoje em "YYYY-MM-DD" — usada para determinar quais colunas
            // exibir por dia (passado/hoje: Previsto+Realizado+Δ; futuro: só Previsto).
            hoje: (function () {
                var d = new Date();
                return d.getFullYear() + '-'
                    + ('0' + (d.getMonth() + 1)).slice(-2) + '-'
                    + ('0' + d.getDate()).slice(-2);
            })()
        };
    },
    mounted: function () {
        var self = this;
        this.$nextTick(function () { self.calcularTopOffsets(); });
    },
    computed: {
        tipos: function () {
            return this.previstoRealizado ? ['Previsto', 'Realizado', 'Delta'] : ['Realizado'];
        },
        semDados: function () {
            return this.datasUnicas.length === 0;
        },
        colsPorDia: function () { return this.tipos.length; },
        alturaHeader: function () { return this.previstoRealizado ? 4 : 3; },
        // Datas únicas vindas das 3 fontes (saldos + movimentações)
        datasUnicas: function () {
            var datasMap = {};
            var addData = function (d) {
                if (!d) return;
                var k = normalizarParaISO(d);
                if (!k) return;
                if (!datasMap[k]) {
                    var partes = k.split('-');
                    var date = new Date(+partes[0], +partes[1] - 1, +partes[2]);
                    if (isNaN(date.getTime())) return;
                    datasMap[k] = date;
                }
            };
            (this.movimentacoes || []).forEach(function (m) { addData(m.data); });
            if (this.saldoInicialData && this.saldoInicialData.datas) {
                this.saldoInicialData.datas.forEach(addData);
            }
            if (this.saldoFinalData && this.saldoFinalData.datas) {
                this.saldoFinalData.datas.forEach(addData);
            }
            var result = Object.keys(datasMap).sort().map(function (k) { return datasMap[k]; }).filter(function (d) { return !isNaN(d.getTime()); });
            return result;
        },
        // Estrutura hierárquica do header (Ano > Mês > Dia)
        cabecalho: function () {
            var dias = [];
            var anosMap = {};
            var mesesMap = {};
            var self = this;
            this.datasUnicas.forEach(function (date) {
                var ano = date.getFullYear();
                var mes = date.getMonth() + 1;
                var dia = date.getDate();
                var anoStr = String(ano);
                var mesStr = ('0' + mes).slice(-2);
                var diaStr = ('0' + dia).slice(-2);
                var dataKey = anoStr + '-' + mesStr + '-' + diaStr;
                var mesId = anoStr + '-' + mesStr;
                if (!anosMap[anoStr]) anosMap[anoStr] = { ano: anoStr, colspan: 0 };
                anosMap[anoStr].colspan += self.tiposPorDia(dataKey).length;
                if (!mesesMap[mesId]) mesesMap[mesId] = { id: mesId, nome: self.nomeMes(mes), colspan: 0 };
                mesesMap[mesId].colspan += self.tiposPorDia(dataKey).length;
                dias.push({ id: dataKey, dataKey: dataKey, label: diaStr + '/' + mesStr + '/' + anoStr });
            });
            return {
                anos: Object.keys(anosMap).sort().map(function (k) { return anosMap[k]; }),
                meses: Object.keys(mesesMap).sort().map(function (k) { return mesesMap[k]; }),
                dias: dias
            };
        },
        totalColunas: function () {
            var self = this;
            var colsTotal = this.cabecalho.dias.reduce(function (acc, dia) {
                return acc + self.tiposPorDia(dia.dataKey).length;
            }, 0);
            return 1 + colsTotal + 1;
        },
        // Constrói árvore hierárquica de movimentações concatenando os níveis das
        // dimensões ativas em configDimensoes (Conta, Centro de custo, Projeto).
        // Cada dimensão contribui com sua hierarquia (niveis<Dim>) + sua folha
        // (vo.<dim>), respeitando os checkboxes de profundidade (niveisVisiveis).
        // Ordem: Conta primeiro, depois CC, depois Projeto (paridade com a ordem
        // padrão do dxPivotGrid antigo).
        arvoreMovimentacoes: function () {
            var raiz = { children: {}, valoresPorChave: {} };
            var configDim = this.configDimensoes || {};

            // Constrói o caminho hierárquico de um record considerando as dimensões
            // ativas e níveis visíveis. Retorna array de labels em ordem (raiz → folha).
            var construirCaminho = function (vo) {
                var caminho = [];

                var addDimensao = function (cfg, niveisStr, folhaLabel, nomeDim) {
                    if (!cfg || !cfg.ativo) return;
                    var niveisLista = (niveisStr || '').split('|').filter(function (n) { return n; });
                    var visiveis = cfg.niveisVisiveis || [];
                    niveisLista.forEach(function (lbl, idx) {
                        // Se niveisVisiveis[idx] é false, pula este nível na hierarquia
                        // (mas não afeta a profundidade efetiva do registro).
                        if (visiveis[idx] === false) return;
                        caminho.push({ label: lbl, dimensao: nomeDim });
                    });
                    // Folha (nome da conta/CC/projeto), se diferente do último nível
                    if (folhaLabel && niveisLista.length > 0
                        && folhaLabel !== niveisLista[niveisLista.length - 1]) {
                        caminho.push({ label: folhaLabel, dimensao: nomeDim });
                    } else if (folhaLabel && niveisLista.length === 0) {
                        caminho.push({ label: folhaLabel, dimensao: nomeDim });
                    }
                };

                addDimensao(configDim.conta, vo.niveisConta, vo.conta, 'conta');
                addDimensao(configDim.centroCusto, vo.niveisCentroCusto, vo.centroCusto, 'centroCusto');
                addDimensao(configDim.projeto, vo.niveisProjeto, vo.projeto, 'projeto');

                return caminho;
            };

            (this.movimentacoes || []).forEach(function (vo) {
                var caminho = construirCaminho(vo);
                if (caminho.length === 0) return;

                // Cria/avança nós ao longo do caminho
                var nodo = raiz;
                var pathAcumulado = '';
                var ultimaContaLabel = null;
                var ultimaCCLabel = null;
                caminho.forEach(function (item, idx) {
                    pathAcumulado = pathAcumulado ? pathAcumulado + '|' + item.label : item.label;
                    if (item.dimensao === 'conta') ultimaContaLabel = item.label;
                    if (!nodo.children[item.label]) {
                        nodo.children[item.label] = {
                            label: item.label,
                            dimensao: item.dimensao,
                            contaPai: item.dimensao !== 'conta' ? ultimaContaLabel : null,
                            ccPai:    item.dimensao === 'projeto' ? ultimaCCLabel : null,
                            path: pathAcumulado,
                            nivel: idx,
                            children: {},
                            valoresPorChave: {},
                            eFolha: idx === caminho.length - 1,
                            raw: vo
                        };
                    } else if (idx === caminho.length - 1) {
                        nodo.children[item.label].eFolha = true;
                    }
                    if (item.dimensao === 'centroCusto') ultimaCCLabel = item.label;
                    nodo = nodo.children[item.label];
                });

                // Acumula valor por (dataKey, tipo)
                var dataKey = normalizarParaISO(vo.data);
                if (!dataKey) return; // data inválida — ignora registro
                var tipo = vo.tipo || 'Realizado';
                var chave = dataKey + '|' + tipo;
                nodo.valoresPorChave[chave] = (nodo.valoresPorChave[chave] || 0) + (vo.valor || 0);
            });

            // Propaga somas dos filhos para os pais
            var propagar = function (nodo) {
                Object.keys(nodo.children).forEach(function (k) {
                    var filho = nodo.children[k];
                    propagar(filho);
                    Object.keys(filho.valoresPorChave).forEach(function (chave) {
                        nodo.valoresPorChave[chave] = (nodo.valoresPorChave[chave] || 0) + filho.valoresPorChave[chave];
                    });
                });
                nodo.temFilhos = Object.keys(nodo.children).length > 0;
                // Se tem filhos, NÃO é folha (mesmo se algum vo individual marcou eFolha)
                if (nodo.temFilhos) nodo.eFolha = false;
            };
            propagar(raiz);

            return raiz;
        },
        // Lista plana de linhas das movimentações (respeitando expand/collapse)
        linhasMovimentacoesVisiveis: function () {
            var self = this;
            var resultado = [];
            var visitar = function (nodo, paiVisivel) {
                Object.keys(nodo.children).sort().forEach(function (k) {
                    var filho = nodo.children[k];
                    if (paiVisivel) {
                        resultado.push(filho);
                        var expandido = self.noExpandido(filho.path);
                        visitar(filho, expandido);
                    }
                });
            };
            visitar(this.arvoreMovimentacoes, true);
            return resultado;
        }
    },
    watch: {
        // Recalcula offsets quando a linha Tipo aparece/desaparece (altera a altura do thead)
        previstoRealizado: function () {
            var self = this;
            this.$nextTick(function () { self.calcularTopOffsets(); });
        },
        arvoreMovimentacoes: {
            immediate: true,
            handler: function (raiz) {
                if (!raiz || !raiz.children) return;
                var self = this;
                var expandirTodos = function (nodo) {
                    Object.keys(nodo.children).forEach(function (k) {
                        var filho = nodo.children[k];
                        if (filho.temFilhos) {
                            self.$set(self.nosExpandidos, filho.path, true);
                            expandirTodos(filho);
                        }
                    });
                };
                expandirTodos(raiz);
            }
        }
    },
    methods: {
        // Retorna os tipos de coluna visíveis para uma data específica.
        // Datas até hoje: Previsto + Realizado + Delta. Datas futuras: só Previsto.
        // Quando previstoRealizado=false, sempre retorna apenas Realizado.
        tiposPorDia: function (dataKey) {
            if (!this.previstoRealizado) return ['Realizado'];
            return dataKey <= this.hoje
                ? ['Previsto', 'Realizado', 'Delta']
                : ['Previsto'];
        },
        // Mede a altura real de cada <tr> do thead e acumula os offsets.
        // Necessário porque o header tem 3 ou 4 linhas e cada <th> precisa de
        // um top diferente para que as linhas se sobreponham corretamente.
        calcularTopOffsets: function () {
            var thead = this.$refs.thead;
            if (!thead) return;
            var linhas = thead.querySelectorAll('tr');
            var acc = 0;
            var offsets = [];
            for (var i = 0; i < linhas.length; i++) {
                offsets.push(acc);
                acc += linhas[i].offsetHeight;
            }
            this.topOffsets = offsets;
        },
        nomeMes: function (mes) {
            var nomes = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
                         'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
            return nomes[mes - 1] || mes;
        },
        formatBRL: function (valor) {
            if (valor == null || valor === 0) return '0,00';
            return Number(valor).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        classeCor: function (valor) {
            if (valor == null || valor === 0) return 'font-blue';
            return valor < 0 ? 'font-red' : 'font-blue';
        },
        // === Agrupamento por tipo de conta ===
        grupoAberto: function (secao, idTipoConta) {
            return this.gruposAbertos[secao + '-' + idTipoConta] === true;
        },
        toggleGrupo: function (secao, idTipoConta) {
            var novoValor = !this.grupoAberto(secao, idTipoConta);
            this.$set(this.gruposAbertos, secao + '-' + idTipoConta, novoValor);
            var mirror = secao === 'si' ? 'sf' : 'si';
            this.$set(this.gruposAbertos, mirror + '-' + idTipoConta, novoValor);
        },
        contasAgrupadasPorTipo: function (saldoData) {
            if (!saldoData || !saldoData.contas) return [];
            var grupos = {};
            var ordem = [];
            saldoData.contas.forEach(function (c) {
                var tipo = c.tipoConta || 'Sem tipo';
                var id = c.idTipoConta != null ? String(c.idTipoConta) : 'sem-tipo';
                if (!grupos[id]) {
                    grupos[id] = { tipoConta: tipo, idTipoConta: id, contas: [] };
                    ordem.push(id);
                }
                grupos[id].contas.push(c);
            });
            return ordem
                .sort(function (a, b) {
                    return grupos[a].tipoConta.localeCompare(grupos[b].tipoConta, 'pt-BR', { sensitivity: 'base' });
                })
                .map(function (id) {
                    var g = grupos[id];
                    g.contas = g.contas.slice().sort(function (a, b) {
                        return (a.nome || '').localeCompare(b.nome || '', 'pt-BR', { sensitivity: 'base' });
                    });
                    return g;
                });
        },
        contasOrdenadasFlat: function (saldoData) {
            if (!saldoData || !saldoData.contas) return [];
            return saldoData.contas.slice().sort(function (a, b) {
                return (a.nome || '').localeCompare(b.nome || '', 'pt-BR', { sensitivity: 'base' });
            });
        },
        totalSaldoPorGrupoDia: function (saldoData, contas, dataKey, tipo) {
            var soma = 0;
            var self = this;
            contas.forEach(function (c) {
                soma += self.getValorSaldo(saldoData, c.handle, dataKey, tipo);
            });
            return soma;
        },
        totalGeralPorGrupoSaldo: function (saldoData, contas) {
            var soma = 0;
            var self = this;
            contas.forEach(function (c) {
                soma += self.totalGeralPorContaSaldo(saldoData, c.handle);
            });
            return soma;
        },
        // === Saldos ===
        getValorSaldo: function (saldoData, contaHandle, dataKey, tipo) {
            if (!saldoData || !saldoData.valores) return 0;
            var c = saldoData.valores[contaHandle];
            if (!c) return 0;
            var d = c[dataKey];
            if (!d) return 0;
            if (tipo === 'Delta') return (d.Realizado || 0) - (d.Previsto || 0);
            return d[tipo] || 0;
        },
        totalGeralPorContaSaldo: function (saldoData, contaHandle) {
            var soma = 0;
            var self = this;
            this.cabecalho.dias.forEach(function (dia) {
                self.tiposPorDia(dia.dataKey).forEach(function (tipo) {
                    soma += self.getValorSaldo(saldoData, contaHandle, dia.dataKey, tipo);
                });
            });
            return soma;
        },
        totalSaldoPorDia: function (saldoData, dataKey, tipo) {
            if (!saldoData || !saldoData.contas) return 0;
            var soma = 0;
            var self = this;
            saldoData.contas.forEach(function (c) {
                soma += self.getValorSaldo(saldoData, c.handle, dataKey, tipo);
            });
            return soma;
        },
        totalGeralSecao: function (qual) {
            var saldoData = qual === 'saldoInicial' ? this.saldoInicialData : this.saldoFinalData;
            if (!saldoData || !saldoData.contas) return 0;
            var soma = 0;
            var self = this;
            saldoData.contas.forEach(function (c) {
                soma += self.totalGeralPorContaSaldo(saldoData, c.handle);
            });
            return soma;
        },
        // === Árvore de movimentações ===
        getValorNo: function (nodo, dataKey, tipo) {
            if (tipo === 'Delta') {
                var p = nodo.valoresPorChave[dataKey + '|Previsto'] || 0;
                var r = nodo.valoresPorChave[dataKey + '|Realizado'] || 0;
                return r - p;
            }
            return nodo.valoresPorChave[dataKey + '|' + tipo] || 0;
        },
        totalGeralNo: function (nodo) {
            var soma = 0;
            var self = this;
            this.cabecalho.dias.forEach(function (dia) {
                self.tiposPorDia(dia.dataKey).forEach(function (tipo) {
                    soma += self.getValorNo(nodo, dia.dataKey, tipo);
                });
            });
            return soma;
        },
        // === Expand/collapse ===
        noExpandido: function (path) {
            return !!this.nosExpandidos[path];
        },
        toggleNo: function (path) {
            this.$set(this.nosExpandidos, path, !this.nosExpandidos[path]);
        },
        toggleSecao: function (qual) {
            this.secoesAbertas[qual] = !this.secoesAbertas[qual];
        },
        onCelulaClique: function (linha, dia, tipo) {
            clearTimeout(this._expandTimer);
            var tipoNum = tipo === 'Previsto' ? 1 : tipo === 'Realizado' ? 2 : tipo === 'Delta' ? 3 : 0;
            var ehCC = linha.dimensao === 'centroCusto';
            var ehProjeto = linha.dimensao === 'projeto';
            var payload = {
                estrutura: (ehCC || ehProjeto) ? linha.contaPai : linha.label,
                data:      dia.dataKey,
                tipo:      tipoNum,
                ehCC:      ehCC,
                ehProjeto: ehProjeto
            };
            if (ehCC) payload.estruturaAuxiliar = linha.label;
            if (ehProjeto) {
                payload.estruturaAuxiliar = linha.ccPai;
                payload.estruturaProjeto  = linha.label;
            }
            this.$emit('cell-click', payload);
        },
        // Handler único da linha inteira: nós com filhos expandem/colapsam.
        // Faz com que clicar em qualquer parte da linha (texto, células, espaço
        // em branco) responda — não só na setinha.
        onLinhaClickGeral: function (linha) {
            var self = this;
            clearTimeout(this._expandTimer);
            this._expandTimer = setTimeout(function () {
                if (linha.temFilhos) {
                    self.toggleNo(linha.path);
                }
            }, 250);
        },
        // Expande um nível a mais na hierarquia de movimentações: encontra o
        // nível mais raso entre os nós visíveis que têm filhos mas ainda não
        // estão expandidos e expande todos nesse nível.
        expandirNivel: function () {
            var visiveis = this.linhasMovimentacoesVisiveis;
            var self = this;
            var nivelMin = Infinity;
            visiveis.forEach(function (linha) {
                if (linha.temFilhos && !self.noExpandido(linha.path) && linha.nivel < nivelMin) {
                    nivelMin = linha.nivel;
                }
            });
            if (nivelMin === Infinity) return;
            visiveis.forEach(function (linha) {
                if (linha.temFilhos && !self.noExpandido(linha.path) && linha.nivel === nivelMin) {
                    self.$set(self.nosExpandidos, linha.path, true);
                }
            });
        },
        // Colapsa o nível mais profundo da hierarquia de movimentações:
        // encontra o nível mais fundo entre os nós expandidos e colapsa todos
        // nesse nível.
        colapsarNivel: function () {
            var visiveis = this.linhasMovimentacoesVisiveis;
            var self = this;
            var nivelMax = -1;
            visiveis.forEach(function (linha) {
                if (linha.temFilhos && self.noExpandido(linha.path) && linha.nivel > nivelMax) {
                    nivelMax = linha.nivel;
                }
            });
            if (nivelMax === -1) return;
            visiveis.forEach(function (linha) {
                if (linha.temFilhos && self.noExpandido(linha.path) && linha.nivel === nivelMax) {
                    self.$set(self.nosExpandidos, linha.path, false);
                }
            });
        }
    }
};
</script>

<style scoped>
.fcg-tabela-wrapper {
    border: 1px solid #c4cfd9;
    background: #fff;
    overflow-x: auto;
    overflow-y: auto;
}

.fcg-tabela {
    /* border-separate garante que cada célula possui suas próprias bordas,
       fazendo-as viajar junto com position:sticky ao rolar */
    border-collapse: separate;
    border-spacing: 0;
    border-top: 1px solid #d8e0e7;
    border-left: 1px solid #d8e0e7;
    width: 100%;
    font-size: 13px;
    font-family: 'Open Sans', 'Helvetica', Arial, sans-serif;
    color: #333;
}

.fcg-tabela th,
.fcg-tabela td {
    /* right + bottom evitam bordas duplas com border-separate */
    border-right: 1px solid #d8e0e7;
    border-bottom: 1px solid #d8e0e7;
    padding: 4px 8px;
    text-align: right;
    white-space: nowrap;
    height: 22px;
    line-height: 1.2;
    vertical-align: middle;
}

.fcg-tabela thead th {
    background: #f5f8fa;
    font-weight: 600;
    text-align: center;
    color: #555;
    box-shadow: 0 2px 4px -1px rgba(0,0,0,0.08);
}

.fcg-tabela .col-label {
    text-align: left;
    background: #fff;
    font-weight: normal;
    color: #333;
    padding-left: 16px;
    position: sticky;
    left: 0;
    z-index: 1;
    /* Coluna do rótulo: cresce conforme o nome (até 450px), corta com "..." se
       passar disso. O atributo title="..." nas TDs mostra o nome completo no
       tooltip. Indentação reduzida pra 12px por nível (paddingLeft inline)
       pra economizar espaço quando a hierarquia é profunda. */
    min-width: 280px;
    max-width: 450px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-shadow: 2px 0 4px -1px rgba(0,0,0,0.06);
}

.fcg-tabela thead th.col-label {
    z-index: 4; /* corner: sobrepõe headers normais (z:2) e col-label do tbody (z:1) */
    box-shadow: 2px 0 4px -1px rgba(0,0,0,0.06), 0 2px 4px -1px rgba(0,0,0,0.08);
}

.fcg-tabela .col-total-geral {
    background: #f5f8fa;
}

/* Linha-cabeçalho da seção (tira azul-clara) — toda a linha é clicável pra
   colapsar/expandir a seção, não só a setinha. */
.fcg-tabela .fcg-section-header {
    cursor: pointer;
    user-select: none;
}
.fcg-tabela .fcg-section-header td {
    background: #d6e9f8 !important;
    font-weight: 600;
    color: #1e6cc7;
    text-align: left;
    padding: 6px 12px;
    border-top: 2px solid #1e6cc7;
}
.fcg-tabela .fcg-section-header:hover td {
    background: #c2deef !important;
}

/* Linha-tipo (Previsto/Realizado/Δ) */
.fcg-tabela .fcg-row-tipos th {
    background: #fafbfc;
    font-size: 12px;
    font-weight: 500;
}

/* Cabeçalho de grupo por tipo de conta */
.fcg-tabela .fcg-group-header {
    cursor: pointer;
}
.fcg-tabela .fcg-group-header td {
    background: #eaf1f8 !important;
    font-weight: 600;
    border-top: 1px solid #b8d0e8;
    font-size: 12px;
    padding: 4px 8px;
}
.fcg-tabela .fcg-group-header td.col-label {
    color: #2c5f8a;
    text-align: left;
    padding: 4px 16px;
}
.fcg-tabela .fcg-group-header td:not(.col-label) {
    text-align: right;
}

/* Linha de total da seção */
.fcg-tabela .fcg-section-total td {
    background: #e8eef5 !important;
    font-weight: 600;
}

.fcg-tabela .fcg-section-total td.col-label {
    background: #e8eef5;
    z-index: 1;
    box-shadow: 2px 0 4px -1px rgba(0,0,0,0.06);
}

/* Linhas clicáveis: nós com filhos (expandem/colapsam).
   Hover destaca a linha toda pra dar feedback visual de que é clicável em qualquer
   coluna, não só na setinha. */
.fcg-tabela .fcg-row-clickable {
    cursor: pointer;
}
.fcg-tabela .fcg-row-clickable:hover td {
    background: #eef5fc;
}

.fcg-expand-toggle {
    display: inline-block;
    width: 14px;
    color: #1e6cc7;
    cursor: pointer;
    font-size: 10px;
    margin-right: 4px;
    user-select: none;
}
.fcg-expand-toggle:hover {
    color: #0d4a8a;
}

.fcg-expand-spacer {
    display: inline-block;
    width: 14px;
    margin-right: 4px;
}

.font-blue { color: #1e6cc7; }
.font-red  { color: #c8312b; }

.fcg-sem-dados {
    padding: 40px;
    text-align: center;
    color: #888;
    font-size: 14px;
}
</style>
